"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
var theme_1 = require("../theme");
exports.CSS = {
    container: 'c-Table',
    title: 'c-Table__Title',
    header: 'c-Table__Header',
    body: 'c-Table__Body',
    row: 'c-Table__row',
    cell: 'c-Table__cell',
    MDL: {
        table: 'mdl-data-table',
        cell: 'mdl-data-table__cell--non-numeric'
    }
};
var TITLE_HEIGHT = theme_1.DefaultTheme.space(12);
exports.Style = (_a = {},
    _a[exports.CSS.container] = {
        'box-shadow': theme_1.DefaultTheme.shadow.box.dp2,
        margin: theme_1.DefaultTheme.space(4)
    },
    _a[exports.CSS.title] = {
        display: 'flex',
        'justify-content': 'space-between',
        height: TITLE_HEIGHT,
        'line-height': TITLE_HEIGHT,
        padding: "0 ".concat(theme_1.DefaultTheme.space(6)),
        '& h6': {
            margin: 0,
            'line-height': TITLE_HEIGHT
        }
    },
    _a["".concat(exports.CSS.header, " th")] = {
        'font-weight': theme_1.DefaultTheme.font.weight.normal
    },
    _a[exports.CSS.body] = {
        width: '100%',
        border: 0,
        'background-color': 'transparent',
        'table-layout': 'fixed',
        '& td:first-of-type, & th:first-of-type': {
            width: '100px'
        }
    },
    _a[exports.CSS.cell] = {
        'max-width': '100%',
        'text-overflow': 'ellipsis',
        'white-space': 'nowrap',
        overflow: 'hidden'
    },
    _a);
//# sourceMappingURL=table.style.js.map